import type { ReactNode } from 'react';

interface Props {
  rotulo: string;
  valor: string;
  sub?: ReactNode;
  tom?: 'neutro' | 'verde' | 'ambar' | 'vermelho' | 'azul';
  onClick?: () => void;
  /** 0..1 — barra de progresso fina embaixo (ex.: % recebido). */
  progresso?: number;
}

const TONS: Record<NonNullable<Props['tom']>, string> = {
  neutro: 'text-slate-800 dark:text-slate-100',
  verde: 'text-emerald-600 dark:text-emerald-400',
  ambar: 'text-amber-600 dark:text-amber-400',
  vermelho: 'text-rose-600 dark:text-rose-400',
  azul: 'text-blue-700 dark:text-blue-300',
};
const BARRA: Record<NonNullable<Props['tom']>, string> = {
  neutro: 'bg-slate-400', verde: 'bg-emerald-500', ambar: 'bg-amber-500',
  vermelho: 'bg-rose-500', azul: 'bg-blue-500',
};

export function KpiCard({ rotulo, valor, sub, tom = 'neutro', onClick, progresso }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!onClick}
      className={`text-left bg-white dark:bg-slate-900/40 rounded-xl border border-slate-200 dark:border-slate-700 p-3.5 transition ${
        onClick ? 'hover:border-blue-300 dark:hover:border-blue-700 cursor-pointer' : 'cursor-default'
      }`}
    >
      <div className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400 truncate">{rotulo}</div>
      <div className={`mt-1 text-lg font-semibold tabular-nums ${TONS[tom]}`}>{valor}</div>
      {sub != null && <div className="mt-0.5 text-[11px] text-slate-500 dark:text-slate-400">{sub}</div>}
      {typeof progresso === 'number' && (
        <div className="mt-2 h-1 rounded-full bg-slate-200 dark:bg-slate-700 overflow-hidden">
          <div className={`h-full rounded-full ${BARRA[tom]}`} style={{ width: `${Math.max(0, Math.min(100, progresso * 100))}%` }} />
        </div>
      )}
    </button>
  );
}
